import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../../redux/modules/store';
import customCountList from '../../../component/organisms/CustomCountList';


const mapStateToProps = (appState: AppState) => {
  return {
    inputValue: appState.customCountList.customCountList,
    loadingStatus: appState.loadingStatus.summary
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(customCountList);
